import React from 'react'
import SpaceKey from '../Icons/SpaceBtn/SpaceBtn.js'
import DeleteKey from '../Icons/DeleteBtn/DeleteBtn.js'
import { KeyTogglerProperties, KeyBoardDistributionEnum } from './types'

export const setKeyProperties = (
  label: string
): { keyName: string; keyTxt: string | JSX.Element; keyTTS: string } => {
  const keyName = `Key${label}`
  let keyTxt: string | JSX.Element = label
  let keyTTS = label

  switch (keyName) {
    case 'KeySpaceAlpha':
    case 'KeySpaceNumeric':
      keyTxt = (
        <SpaceKey fill="#fff" strokeOpacity="0.6" width="64" height="28" />
      )
      keyTTS = 'Space Key'
      break
    case 'KeyDeleteAlpha':
    case 'KeyDeleteNumeric':
      keyTxt = (
        <DeleteKey fill="#fff" fillOpacity="0.6" width="44" height="31" />
      )
      keyTTS = 'Delete Key'
      break
  }

  return {
    keyName,
    keyTxt,
    keyTTS,
  }
}

export const setKeyboardDistributionTogglerProperties = (
  keyToggler: KeyBoardDistributionEnum
): KeyTogglerProperties => {
  let keyLabel = ''
  let keyTTS = ''

  switch (keyToggler) {
    case KeyBoardDistributionEnum.alpha:
      keyLabel = keyTTS = 'ABC'
      break
    case KeyBoardDistributionEnum.numeric:
      keyLabel = '123'
      keyTTS = '1,2,3'
      break
  }

  return {
    keyToggler,
    keyLabel,
    keyTTS,
  }
}
